import { useTranslation } from 'react-i18next';

export const useCopyToClipboard = () => {
  const { t } = useTranslation();
  return (copyButtonId: string, elementToCopyId: string) => {
    const copyButton = document.getElementById(copyButtonId);
    const elementToCopy = document.getElementById(elementToCopyId);
    const body = document.querySelector('body');
    if (
      !copyButton ||
      !body ||
      !elementToCopy ||
      !elementToCopy.textContent ||
      !document.execCommand
    ) {
      return;
    }
    const originalCopyButtonText = copyButton.textContent || '';
    const area = document.createElement('textarea');
    area.setAttribute(
      'style',
      'border: 0; clip: rect(0 0 0 0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; width: 1px;',
    );
    body.appendChild(area);
    area.value = elementToCopy.textContent;
    area.select();
    document.execCommand('copy');
    body.removeChild(area);

    copyButton.innerHTML = t('common.copied');
    setTimeout(function () {
      copyButton.innerHTML = originalCopyButtonText;
    }, 2000);
  };
};
